import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsFacebook, BsGoogle, BsTwitter } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { login, saveTokenInLocalStorage, subscriptionTrial } from "../../services/AuthService";
import apiService from "../../services/ApiService";
import { callAlert, callAlertConfirm } from "../../services/CommonService";
import ReCAPTCHA from "react-google-recaptcha";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { handleEncrypt } from "../../services/CryptoService";
import { AiFillInstagram } from "react-icons/ai";
import { useDispatch } from "react-redux";
function LoginModal(props) {
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [loader, setLoader] = useState(false);
  const [failedAttempts, setFailedAttempts] = useState(0);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [captchaErrorMessage, setCaptchaErrorMessage] = useState("");
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    // Retrieve failed attempts from local storage on component mount
    const storedAttempts =
      parseInt(localStorage.getItem("failedAttempts")) || 0;
    setFailedAttempts(storedAttempts);
  }, []);

  const [state, setState] = React.useState({
    username: "",
    email: "",
    mobile: "",
    password: "",
    confirmpassword: "",
  });

  function onChange(value) {
    console.log("Captcha value:", value);
    setCaptchaVerified(true);
  }

  function reset(ev) {
    ev.preventDefault();
    setState({
      username: "",
      email: "",
      mobile: "",
      password: "",
      confirmpassword: "",
    });
  }

  function handleLoginError(error) {
    setLoader(false);
    callAlert(error?.error?.message);
    const updatedAttempts = failedAttempts + 1;
    localStorage.setItem("failedAttempts", updatedAttempts.toString());
    setFailedAttempts(updatedAttempts);
    if (failedAttempts >= 3) {
      setShowCaptcha(true);
    }
  }
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (state.email === "") {
      errorObj.email = "Please enter username";
      error = true;
    }
    if (state.password === "") {
      errorObj.password = "Please enter password";
      error = true;
    }

    if (showCaptcha) {
      if (!captchaVerified) {
        setCaptchaErrorMessage("Please complete the CAPTCHA!");
        return;
      }
    }

    setErrors(errorObj);
    if (error) {
      return;
    }
    setLoader(true);

    setFailedAttempts(0);
    localStorage.removeItem("failedAttempts");
    loginCheck();
  }

  const loginCheck = (signInHere = false) => {
    apiService
      .postRequest(
        "/users/signin",
        {
          username: state.email,
          password: handleEncrypt(state.password),
          signInHere: signInHere,
        },
        false
      )
      .then((response) => {
        if (response?.data.resultCode === 208) {
          callAlertConfirm(
            "",
            response?.data.message,
            (result) => {
              if (result.isConfirmed) {
                setTimeout((d) => {
                  loginCheck(true);
                }, 100);
              } else if (result.isDenied) {
                setLoader(false);
              }
            },
            false
          );
        } else {
          if (response?.data.data) {
            setLoader(false);
            saveTokenInLocalStorage(response?.data?.data);
             
                                         
              subscriptionTrial(d=>{ 
                   navigate(d?d:`/user/dashboard`, { 
                                           });
                           setTimeout((d) => {
                            window.location.reload();
                          }, 10000);
                                         },dispatch);
           
             
          } else {
            setLoader(false);
            callAlert("", response.data?.message);
          }
        }
      })
      .catch((error) => {
        setLoader(false);
        callAlert("", error?.error?.message);
        handleLoginError(error);
      });
  };

  return (
    <div className="container">
      {/* use this button to trigger this modal */}
      {/* <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#loginModal">
            Login
        </button> */}

      <div
        className="modal fade"
        id="loginModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="loginModalTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title fw-bold" id="loginModalTitle">
                Sign In
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body d-flex justify-content-center mb-3  bg-white">
              <div className="  col-md-12 p-0">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <h4 className="text-center mb-4 mt-4">Sign In</h4>
                    <p>Become a part of our community EFH!</p>
                    {props?.errorMessage && (
                      <div className="text-danger p-1 my-2">
                        {props?.errorMessage}
                      </div>
                    )}
                    {props?.successMessage && (
                      <div className="text-danger p-1 my-2">
                        {props?.successMessage}
                      </div>
                    )}
                    <form onSubmit={onLogin}>
                      <div className="mb-3">
                        <input
                          type="email"
                          className="form-control"
                          value={state.email}
                          onChange={(ev) => {
                            setState({ ...state, email: ev.target.value });
                          }}
                          placeholder="Enter your email"
                        />
                        {errors.email && (
                          <div className="text-danger fs-12">
                            {errors.email}
                          </div>
                        )}
                      </div>
                      <div className="mb-3">
                        {/* <input
                          type="password"
                          className="form-control"
                          value={state.password}
                          placeholder="Enter your password"
                          onChange={(ev) => {
                            setState({ ...state, password: ev.target.value });
                          }}
                        /> */}
                        <div className="d-flex  align-items-center">
                          <input
                            type={showPassword ? "text" : "password"} // Toggle input type
                            className="form-control"
                            value={state.password}
                            placeholder="Enter your password"
                            onChange={(ev) =>
                              setState({
                                ...state,
                                password: ev.target.value,
                              })
                            }
                          />
                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer", marginLeft: "-30px" }}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                          </span>
                        </div>
                        {errors.password && (
                          <div className="text-danger fs-12">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      {showCaptcha && (
                        <>
                          <div className="col">
                            <ReCAPTCHA
                              sitekey="6LdOhwQrAAAAAPEnW5DLqd078hsiQGXGy3NC0I6q"
                              onChange={onChange}
                            />
                          </div>
                          <div>
                            {captchaErrorMessage && (
                              <span className="text-danger">
                                {captchaErrorMessage}
                              </span>
                            )}
                          </div>
                        </>
                      )}

                      {/* <div className="row d-flex justify-content-between mt-1 mb-1">
                        <div className="mb-3">
                          <div className="form-check custom-checkbox ms-1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="basic_checkbox_1"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="basic_checkbox_1"
                            >
                              Remember me
                            </label>
                          </div>
                        </div>
                      </div> */}
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-primary2 btn-block"
                          disabled={loader}
                        >
                          {loader && (
                            <span className="spinner-border spinner-border-sm"></span>
                          )}{" "}
                          LOGIN
                        </button>
                      </div>
                    </form>
                    <div className="new-account mt-3 mb-5">
                      <small className="text-center d-block">
                        Forgot your password? Get help{" "}
                      </small>

                      <hr />
                      <div className=" mb-3 mt-3 text-center hide">
                        <span> Or log in with </span>
                      </div>

                      <ul className="social-media-login hide">
                        <li className="facebook">
                          {" "}
                          <FaFacebookF />
                        </li>

                        <li className="google">
                          <BsGoogle />
                        </li>

                        <li className="instagram">
                          <AiFillInstagram />
                        </li>
                      </ul>

                      <p
                        className=" f14 text-center d-block text-primary"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#registerModal"
                      >
                        Don't have an account yet? Sign up
                      </p>
                      {/* <button type="button" className="btncomponent" data-bs-toggle="modal" data-bs-target="#registerModal">
                                                Register
                                            </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginModal;
